import { Component, OnInit, ViewChild, inject, TemplateRef, Input, OnChanges, SimpleChanges  } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AppCoreService } from 'src/app/services/app-core.service';
import { UserManagementService } from 'src/app/services/user-management.service';
import Swal from "sweetalert2";

export interface IPermissionConfig {
  name: string;
  description: string
  id: number;
  itemid: number;
  checkView: boolean;
  checkAdd: boolean;
  checkEdit: boolean;
  checkDelete: boolean;
  subItemsExist?: boolean;
  subItems?: IPermissionConfig[]
}

export interface IPermissionCategoryTypes {
  category: string;
  configs: IPermissionConfig[]
}

@Component({
  selector: 'app-editpermissions',
  templateUrl: './editpermissions.component.html',
  styleUrls: ['./editpermissions.component.scss']
})

export class EditUserPermissionComponent implements OnInit, OnChanges {
  permissionsForm: FormGroup;
  @Input() public userid;
  permissions: any = {
    categories: [],
    configs: []
  };
  
  permissionCategoryTypes: IPermissionCategoryTypes[] = [];
  useEnterKey: any;

  constructor(
    private appCoreService: AppCoreService,
    public activeModal: NgbActiveModal,
    private ngxLoaderService: NgxUiLoaderService,
    private userManagementService: UserManagementService,
    private _fb: FormBuilder,
    private titleService: Title
  ) {
    titleService.setTitle('Users');
   }

  ngOnInit() {
    this.permissionsForm = this._fb.group({
      categories: this._fb.array([])
    })
    // console.log('roleid', this.roleid);
    this.bindUserDetails();
    const userData = this.appCoreService.GetUserData();
    this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log(changes);
    if (changes['userid'] && changes['userid'].currentValue) {
      // console.log('roleid', this.roleid);
      this.bindUserDetails();
    }
  }

  categories(): FormArray {
    return this.permissionsForm.get('categories') as FormArray;
  }

  newCategory(catName): FormGroup {
    return this._fb.group({
      name: catName,
      id: '',
      subItems: this._fb.array([])
    });
  }

  addCategory(catName) {
    this.categories().push(this.newCategory(catName));
  }

  subItem(itemIndex: number): FormArray {
    return this.categories()
      .at(itemIndex)
      .get('subItems') as FormArray;
  }

  newSubItem(item): FormGroup {
    return this._fb.group({
      name: item.name,
      description: item.description,
      id: item.id,
      itemid: item.itemid,
      checkView: new FormControl({value: item.checkView, disabled: item.checkView === null ? true: false}),
      checkAdd: new FormControl({value: item.checkAdd, disabled: item.checkAdd === null ? true: false}),
      checkEdit: new FormControl({value: item.checkEdit, disabled: item.checkEdit === null ? true: false}),
      checkDelete: new FormControl({value: item.checkDelete, disabled: item.checkDelete === null ? true: false}),
      subItemsExist: item.subItemsExist || false,
      subItems: this._fb.array([])
    });
  }

  addSubItem(itemIndex: number, item) {
    this.subItem(itemIndex).push(this.newSubItem(item));
  }

  addSubItemL2(itemIndex: number, subItemIndex: number, item) {
    (this.subItem(itemIndex).at(subItemIndex).get('subItems') as FormArray).push(this.newSubItem(item));
  }

  addPermissionConfig(): FormGroup {
    return this._fb.group({
      name: '',
      description: '',
      id: '',
      checkView: false,
      checkAdd: false,
      checkEdit: false,
      checkDelete: false,
      subItemsExist: false,
      subItems: this._fb.array([])
    });
  }

  bindUserDetails() {
    if (this.userid) {
      // this.ngxLoaderService.start();
      this.userManagementService.GetById(this.userid).subscribe((res) => {
        if (res && res.success) {
          // this.ngxLoaderService.stop();
          // console.log('res', res);
          if (res.data.length) {
            let uniqueCategories = [...new Set(res.data[0].config.map(item => item.categorytype))];
            // console.log(uniqueCategories);
            
            this.bindPermissionList(res.data[0]);
            this.bindPermissionsForm();
            
            
          }

        }
      });
        // this.ngxLoaderService.stop();
    }
  }

  bindPermissionList(permissions: any) {
    // console.log('permissions: ', permissions);
    if (permissions) {
      // get all parent categories
      const parentCategories = permissions.config.filter(x => x.parentid === null);
      // console.log('parentCategories: ', parentCategories);
      if (parentCategories.length) {
        let uniqueCategories = [...new Set(parentCategories.map(item => item.categorytype))];
        // console.log('uniqueCategories: ', uniqueCategories);
        uniqueCategories.forEach((val: string, idx) => {
          // start binding each unique categories and their details
          let permissionList: IPermissionConfig[] = [];
          const categories = parentCategories.filter(x => x.categorytype === val);
          categories.forEach((val, idx) => {
            let permissionConfig: IPermissionConfig = {
              name: val.categoryname,
              description: val.categorydescription,
              id: val.id,
              itemid: val.itemid,
              checkView: val.view,
              checkAdd: val.add,
              checkEdit: val.edit,
              checkDelete: val.delete,
              subItemsExist: false
            };
            // check if we need to bind subitems
            const subItemsExist = permissions.config.filter(x => x.parentid === val.id);
            // console.log('subItemsExist', subItemsExist);
            if (subItemsExist.length) {
              // bind sub items
              permissionConfig.subItemsExist = true;
              permissionConfig = this.bindSubItems(subItemsExist, permissionConfig, permissions.config);
            }
            
            permissionList.push(permissionConfig);

          });

          // console.log('this.permissionList: ', permissionList);

          // bind categories
          this.permissionCategoryTypes.push({
            category: val,
            configs: permissionList
          });

        });

        // console.log('this.permissionCategoryTypes: ', this.permissionCategoryTypes);
      }
    }
  }

  bindSubItems(subItems: any[], config: IPermissionConfig, permissions: any[]) {
    let items: IPermissionConfig[] = [];
    subItems?.forEach((val, idx) => {
      let permissionConfig: IPermissionConfig = {
        name: val.categoryname,
        description: val.categorydescription,
        id: val.id,
        itemid: val.itemid,
        checkView: val.view,
        checkAdd: val.add,
        checkEdit: val.edit,
        checkDelete: val.delete,
        subItemsExist: false
      };
      // check if we need to bind subitems
      const subItemsExist = permissions.filter(x => x.parentid === val.id);
      // console.log('subItemsExist', subItemsExist);
      if (subItemsExist.length) {
        // bind sub items
        permissionConfig.subItemsExist = true;
        permissionConfig = this.bindSubItems(subItemsExist, permissionConfig, permissions);
      }

      items.push(permissionConfig);
    });

    config.subItems = items;
    return config;
  }

  bindPermissionsForm() {
    this.permissionCategoryTypes.forEach((val, idx) => {
      this.addCategory(val.category);

      val.configs.forEach((cfg, cfgIdx) => {
        // console.log('cfg', cfg);
        this.addSubItem(idx, cfg);
        if (cfg.subItemsExist) {
          cfg.subItems.forEach((si, i) => {
            this.addSubItemL2(idx, cfgIdx, si);
          })
        }
      })

    });
  }

  onViewCheck(parentIdx, currIdx, item, evt) {
    // console.log('add check', parentIdx, currIdx, item, evt);
    // console.log(this.subItem(parentIdx).at(currIdx));
    
    const isViewSelected = evt.target.checked;
    // console.log('isViewSelected', isViewSelected);
    
    // check if subitems exists
    if (this.subItem(parentIdx).at(currIdx).get('subItemsExist')) {
      const subItems = this.subItem(parentIdx).at(currIdx).get('subItems') as FormArray;
      subItems.controls.forEach((item, idx) => {
        item.get('checkView').setValue(isViewSelected);
      });
    }
    
  }

  onAddCheck(parentIdx, currIdx, item, evt) {
    const isAddSelected = evt.target.checked;
    // console.log('isAddSelected', isAddSelected);
    // check is View enabled or not ?
    const isViewSelected = this.subItem(parentIdx).at(currIdx).get('checkView').value;
    // console.log('isViewSelected', isViewSelected);
    if (isAddSelected) {
      if (!isViewSelected) {
        this.subItem(parentIdx).at(currIdx).get('checkView').setValue(isAddSelected);
      }
      
    }

    // check if subitems exists
    if (this.subItem(parentIdx).at(currIdx).get('subItemsExist')) {
      const subItems = this.subItem(parentIdx).at(currIdx).get('subItems') as FormArray;
      // console.log('subItems', subItems);
      subItems.controls.forEach((item, idx) => {
        if (!isViewSelected || !item.get('checkView').value) {
          item.get('checkView').setValue(isAddSelected);  
        }
        item.get('checkAdd').setValue(isAddSelected);
      });
    }
    
  }

  onEditCheck(parentIdx, currIdx, item, evt) {
    // console.log('add check', parentIdx, currIdx, item, evt);
    const isEditSelected = evt.target.checked;
    // console.log('isEditSelected', isEditSelected);
    // check is View enabled or not ?
    const isViewSelected = this.subItem(parentIdx).at(currIdx).get('checkView').value;
    if (isEditSelected) {
      if (!isViewSelected) {
        this.subItem(parentIdx).at(currIdx).get('checkView').setValue(isEditSelected);
      }
    }

    // check if subitems exists
    if (this.subItem(parentIdx).at(currIdx).get('subItemsExist')) {
      const subItems = this.subItem(parentIdx).at(currIdx).get('subItems') as FormArray;
      // console.log('subItems', subItems);
      subItems.controls.forEach((item, idx) => {
        if (!isViewSelected || !item.get('checkView').value) {
          item.get('checkView').setValue(isEditSelected);  
        }
        item.get('checkEdit').setValue(isEditSelected);
      });
    }
    
  }

  onDeleteCheck(parentIdx, currIdx, item, evt) {
    // console.log('add check', parentIdx, currIdx, item, evt);
    const isDeleteSelected = evt.target.checked;
    // console.log('isDeleteSelected', isDeleteSelected);
    // check is View enabled or not ?
    const isViewSelected = this.subItem(parentIdx).at(currIdx).get('checkView').value;
    if (isDeleteSelected) {
      if (!isViewSelected) {
        this.subItem(parentIdx).at(currIdx).get('checkView').setValue(isDeleteSelected);
      }
    }
    
    // check if subitems exists
    if (this.subItem(parentIdx).at(currIdx).get('subItemsExist')) {
      const subItems = this.subItem(parentIdx).at(currIdx).get('subItems') as FormArray;
      // console.log('subItems', subItems);
      subItems.controls.forEach((item, idx) => {
        if (!isViewSelected || !item.get('checkView').value) {
          item.get('checkView').setValue(isDeleteSelected);  
        }
        item.get('checkDelete').setValue(isDeleteSelected);
      });
    }
  }

  onSaveClick() {
    // console.log('saved click');
    const categories = this.permissionsForm.value?.categories;
    const rolePermissions: any[] = [];

    categories.forEach((elem, idx) => {
      const categoryName = elem.name;
      if (elem.subItems) {
        elem.subItems.forEach((item, i) => {
          rolePermissions.push({
            id: item.id,
            itemid: item.itemid,
            categoryname: item.name,
            categorydescription: item.description,
            categorytype: categoryName,
            parentid: item.parentid,
            view: item.checkView,
            add: item.checkAdd,
            edit: item.checkEdit,
            delete: item.checkDelete
          });

          item.subItems.forEach((subItem, itr) => {
            rolePermissions.push({
              id: subItem.id,
              itemid: subItem.itemid,
              categoryname: subItem.name,
              categorydescription: subItem.description,
              categorytype: categoryName,
              parentid: subItem.parentid,
              view: subItem.checkView,
              add: subItem.checkAdd,
              edit: subItem.checkEdit,
              delete: subItem.checkDelete
            });
          })
        })
      }
    });

    // console.log('rolePermissions', rolePermissions);
    // this.activeModal.close('Save Click');
    let requestObj = {
      userid: this.userid,
      permissions: rolePermissions
    }

    let msg = `Are you sure you want to Set user level permissions ?`;
    this.openConfirmationDialog(msg).then((result) => {
      // console.log(result);
      if (result) {
        // save the user permissions
        this.userManagementService.SaveUserPermissions(requestObj).subscribe((res) => {
          if (res && res.success) {
            this.appCoreService.showMessage('User permissions are updated successfully', '');
            this.activeModal.close('Save Click');
          }
        });
      }
    });
    
  }

  onResetClick() {
    let msg = `Are you sure you want to Reset the permissions to role based permissions ?`;
    this.openConfirmationDialog(msg).then((result) => {
      // console.log(result);
      if (result) {
        // reset the user permissions
        this.userManagementService.DeleteUserPermissions(this.userid).subscribe((res) => {
          if (res && res.success) {
            this.appCoreService.showMessage('User permissions resetted successfully', '');
            this.activeModal.close('Save Click');
          }
        });
      }
    });
  }

  async openConfirmationDialog(msg: any, id?: number) {
    const result = await Swal.fire({
        titleText: 'Confirmation',
        text: msg,
        icon: 'warning',
        confirmButtonText: 'Yes',
        showDenyButton: true,
        denyButtonText: 'No',
        allowEscapeKey: false,
        allowOutsideClick: false
    });
    return result.isConfirmed;
}
  
}
